import API from '../Services/API';
import Model from './Model';

const useVerification = (alwaysRefresh = true) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'verification',
        stateKey: 'verification',
        fetchData: () => API.get('/verification'),
        registerAdditionalMethods: (opts) => {
            return {
                verifyPhoneNumber: (payload) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/verification/phoneNumber', payload),
                        payload.code ? 'Your phone number has been verified' : 'Verification code sent',
                        true,
                    );
                },
                verifyEmail: (payload) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/verification/email', payload),
                        'Verification link sent',
                        true,
                    );
                },
                verifyIdentity: (payload) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/verification/identity', payload),
                        'Verification session ready',
                        true,
                    );
                },
                verifyAddress: (payload) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/verification/address', payload),
                        payload.code ? 'Your address has been verified' : 'Address verification requested',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Failed to load verification.',
    });
}

export {
    useVerification,
}
